/** Request header carrying the commit SHA the calling frontend bundle was built from. */
export const CLIENT_BUILD_HEADER = 'x-gap-client-build'

/** Response header set to `true` when the calling frontend is older than the live one. */
export const FRONTEND_OUTDATED_HEADER = 'x-gap-frontend-outdated'

/** Returns the SSM path holding the comma-separated frontend builds a client may run without being outdated. */
export const acceptedFrontendBuildsParameterPath = (stage: string) => `/sst-v3/${stage}/site/accepted-frontend-builds`
